import MyPhotoAPI from '@/api/myPhoto'

// state
const _state = {
  submitting: false,
}

// getters
const _getters = {
}

// mutations
const mutations = {
  SET_SUBMITTING(state, submitting) {
    state.submitting = submitting
  },
}

// actions
const actions = {
  async deleteImageAction({ commit }, params) {
    commit('SET_SUBMITTING', true)
    await MyPhotoAPI.deleteImage(params)
    commit('SET_SUBMITTING', false)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
